<ng-container [ngSwitch]="type">
  <!-- text -->
  <ng-container *ngSwitchCase="'text'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{ value | checkValue }}</span
    >
  </ng-container>

  <!-- number -->
  <ng-container *ngSwitchCase="'number'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{ value | numberSeparator | checkValue }}</span
    >
  </ng-container>

  <!-- boolean -->
  <ng-container *ngSwitchCase="'boolean'">
    <span>
      <i class="mdi mdi-check-bold text-success mdi-18px" *ngIf="value"></i>
      <i class="mdi mdi-close-thick text-danger mdi-18px" *ngIf="!value"></i>
    </span>
  </ng-container>

  <!-- date -->
  <ng-container *ngSwitchCase="'date'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{
        value | dateConverter : translationService.currentLang() | checkValue
      }}
    </span>
  </ng-container>

  <!-- dateTime -->
  <ng-container *ngSwitchCase="'dateTime'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{
        value
          | dateTimeConvertor : translationService.currentLang()
          | checkValue
      }}
    </span>
  </ng-container>

  <ng-container *ngSwitchCase="'dateTimeWithSecond'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{
        value
          | dateTimeWithSecondConvertor : translationService.currentLang()
          | checkValue
      }}
    </span>
  </ng-container>

  <ng-container *ngSwitchCase="'dateTimeWithSpace'">
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      [innerHTML]="
        value
          | dateTimeWithSpaceConvertor : translationService.currentLang()
          | checkValue
      "
    >
    </span>
  </ng-container>

  <!-- default -->
  <ng-container *ngSwitchDefault>
    <span
      class="dark:tw-text-gray-300"
      [class]="fontSize == 'sm' ? 'tw-text-[12px]' : 'tw-text-[13px]'"
      >{{ value | checkValue }}</span
    >
  </ng-container>
</ng-container>

